var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 16.8389H12.5625V12.8389H11.5625M12.5625 8.83887H12.5725M21.5625 12.8389C21.5625 14.0208 21.3297 15.1911 20.8774 16.283C20.4251 17.3749 19.7622 18.3671 18.9265 19.2028C18.0907 20.0386 17.0986 20.7015 16.0067 21.1538C14.9147 21.6061 13.7444 21.8389 12.5625 21.8389C11.3806 21.8389 10.2103 21.6061 9.11835 21.1538C8.02642 20.7015 7.03427 20.0386 6.19854 19.2028C5.36281 18.3671 4.69988 17.3749 4.24758 16.283C3.79529 15.1911 3.5625 14.0208 3.5625 12.8389C3.5625 10.4519 4.51071 8.16273 6.19854 6.47491C7.88637 4.78708 10.1756 3.83887 12.5625 3.83887C14.9494 3.83887 17.2386 4.78708 18.9265 6.47491C20.6143 8.16273 21.5625 10.4519 21.5625 12.8389Z",
    stroke: "#FFA87D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle);
export default __webpack_public_path__ + "static/media/information-circle.23f4cbb0f3247ef7a768e1593b8e042c.svg";
export { ForwardRef as ReactComponent };